import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LeafletDirective } from './leaflet.directive';
import { LeafletDrawDirective } from './leaflet-draw.directive';

@NgModule({
  declarations: [LeafletDirective, LeafletDrawDirective],
  imports: [CommonModule],
  exports: [LeafletDirective, LeafletDrawDirective],
})
export class LeafletCompatModule { }
